// NDR Exhausts — shared site behavior

document.addEventListener('DOMContentLoaded', () => {

  /* mobile menu */
  const toggle = document.querySelector('.nav-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      toggle.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        toggle.classList.remove('open');
      });
    });
  }

  /* scroll reveal */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('in'));
  }

  /* animated stat counters */
  const counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window && counters.length) {
    const cio = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseFloat(el.dataset.count);
        const suffix = el.dataset.suffix || '';
        const duration = 1400;
        const start = performance.now();
        const step = (now) => {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          const val = target < 10 ? (target * eased).toFixed(1) : Math.floor(target * eased);
          el.textContent = val + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        cio.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(el => cio.observe(el));
  }

  /* decibel bars */
  const decibel = document.querySelector('.decibel');
  if (decibel) {
    for (let i = 0; i < 28; i++) {
      const bar = document.createElement('i');
      bar.style.animationDelay = (i * 0.06) + 's';
      bar.style.height = (30 + Math.random() * 70) + '%';
      decibel.appendChild(bar);
    }
  }

  /* shop: brand chips + part-type toggle (combined so neither filter clobbers the other) */
  const chips = document.querySelectorAll('.chip[data-target]');
  const typeButtons = document.querySelectorAll('.type-toggle button');
  if (chips.length || typeButtons.length) {
    let currentBrand = 'all';
    let currentType = 'all';

    const applyFilters = () => {
      document.querySelectorAll('.brand-block').forEach(block => {
        const brandMatches = currentBrand === 'all' || block.dataset.brand === currentBrand;
        let anyCardVisible = false;
        block.querySelectorAll('[data-type]').forEach(card => {
          const typeMatches = currentType === 'all' || card.dataset.type === currentType;
          const show = brandMatches && typeMatches;
          card.style.display = show ? '' : 'none';
          if (show) anyCardVisible = true;
        });
        block.style.display = anyCardVisible ? '' : 'none';
      });
    };

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        currentBrand = chip.dataset.target;
        applyFilters();
        if (currentBrand !== 'all') {
          const y = document.querySelector('.filter-bar').getBoundingClientRect().bottom + window.scrollY - 100;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });

    typeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        typeButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        currentType = btn.dataset.type;
        applyFilters();
      });
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.accordion-item').forEach(item => {
    const btn = item.querySelector('button');
    const panel = item.querySelector('.accordion-panel');
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item.open').forEach(o => {
        o.classList.remove('open');
        o.querySelector('.accordion-panel').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* contact form: static demo submit */
  const form = document.querySelector('.quote-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const original = btn.textContent;
      btn.textContent = 'Request Sent';
      btn.disabled = true;
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
        form.reset();
      }, 2600);
    });
  }

  /* nav active link */
  const path = location.pathname.split('/').pop() || 'index.html';
  document.querySelectorAll('.nav-links a, .mobile-menu a').forEach(a => {
    if (a.getAttribute('href') === path) a.classList.add('active');
  });
});
